import React, { SyntheticEvent, useCallback } from 'react';
import { Form, useFormikContext } from 'formik';
import { useToast } from '@app/core';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
  className?: string;
  onValidationFailed?: (errors?: any) => any;
  showToast?: boolean;
}

export const ValidatingForm = ({
  children,
  className,
  onValidationFailed,
  showToast,
}: Props) => {
  const { validateForm, handleSubmit } = useFormikContext();
  const { t } = useTranslation();
  const toast = useToast();
  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      try {
        if (onValidationFailed || showToast) {
          const errors = await validateForm();
          if (!!Object.keys(errors).length) {
            if (onValidationFailed) {
              onValidationFailed(errors);
            }

            if (showToast) toast.error(t('toast.invalidForm'));
          }
        }
        handleSubmit(e);
      } catch (e) {
        toast.exception(e);
      }
    },
    [handleSubmit, t, toast, validateForm, onValidationFailed, showToast],
  );
  return (
    <Form onSubmit={onSubmit} className={className}>
      {children}
    </Form>
  );
};
